
import { Component } from 'vue-property-decorator';
import ElementBase from './ElementBase';
import dayjs from 'dayjs';
import DateTimeElementConfiguration from '../configuration/DateTimeElementConfiguration';
import { evaluate } from "../expression";

@Component({ name: 'DateTime' })
export default class DateTime extends ElementBase {
  private date: Date = new Date();
  private task: any = -1;

  private get dateTimeConfiguration(): DateTimeElementConfiguration {
    return this.configuration as DateTimeElementConfiguration;
  }

  private get value(): string {
    return dayjs(this.date).format(evaluate(this.dateTimeConfiguration.formatDayJs, this.bindingsContext) ?? 'YYYY-MM-DD HH:mm:ss');
  }

  async mounted(): Promise<void> {
    await super.mounted();
    this.task = setInterval(() => this.date = new Date(), 200);
  }

  beforeDestroy(): void {
    clearInterval(this.task);
    super.beforeDestroy();
  }
}
